import { API } from 'apis';
import { getViaAuth, responseValidator } from 'apis/api';
import { Role } from 'core/domain';

export const getAllRoles = async (setLoading: any, setData: any, query?: string) => {
    setLoading(true);
    await getViaAuth<Role[]>(API.roles.getAll + `${query || ''}`).then((response) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            if (response.value.items) {
                setData(response.value.items);
            }
        }
    });
};

export const getRoleById = async (
    setLoading: any,
    setData: any,
    setPermissionKeys: any,
    setMenuItemKeys: any,
    id: string,
) => {
    setLoading(true);
    await getViaAuth<Role>(API.roles.getById + `/${id}`).then((response) => {
        setLoading(false);
        if (responseValidator(response.status)) {
            setData(response.value);
            setPermissionKeys(response.value?.permissions?.map((permission) => String(permission)) ?? []);
            setMenuItemKeys(response.value?.menuItems?.map((menuItem) => String(menuItem)) ?? []);
        }
    });
};
